import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import { DepositsTab } from './tabs/deposits/deposits-tab';
import { WaitingForDepositTab } from './tabs/waiting-for-deposit/waiting-for-deposit-tab';
import '../../settings/studies/studies.settings.css';

const tabs = ['הפקדות', 'ממתין להפקדה'];

export const DepositPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const elementTabs = [<DepositsTab />, <WaitingForDepositTab />];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>דו״ח הפקדות</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => onTabSelected(index)}
          activeIndex={selectedIndex}
        />

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
